import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import axios from "axios";
import ChatBot from "@/components/ChatBot";
import AdminDashboard from "@/pages/AdminDashboard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return (
    <div>
      <header className="App-header">
        <a
          className="App-link"
          href="https://directmediaweb.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="https://directmediaweb.com/images/logo_small.png" alt="Direct Media Logo" />
        </a>
        <p className="mt-5 text-2xl font-bold">مرحباً بك في Direct Media</p>
        <p className="mt-3 text-lg text-gray-300">وكالة رقمية متخصصة في التصميم والتطوير والتسويق</p>
        <p className="mt-8 text-sm text-blue-400">💬 جرّب ChatBot الذكي الخاص بنا - اضغط على الزر في الزاوية اليسرى!</p>
      </header>
      <ChatBot />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors closeButton />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/widget" element={<ChatBot />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
